// import { toast } from "sonner";

// export const showToast = (message: string) => {
//   toast.success(message);
// };

// export const showWarning = (message: string) => {
//   toast.dismiss();
//   toast(message || "Something went wrong", {
//     style: { backgroundColor: "#facc15", color: "black" },
//   });
// };

// export const showError = (message: string) => {
//   toast.dismiss();
//   toast.error(message || "Something went wrong");
// };
// toastUtils.ts
import { VariantType, useSnackbar, SnackbarKey } from "notistack";

let useSnackbarRef: any;
export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export const showToast = (message: string) => {
  useSnackbarRef.enqueueSnackbar(message, {
    variant: "success",
    style: { backgroundColor: "white", color: "green" },
  });
};

export const showWarning = (message: string) => {
  useSnackbarRef.closeSnackbar();
  useSnackbarRef.enqueueSnackbar(message || "Something went wrong", {
    variant: "warning",
    style: { backgroundColor: "white", color: "black" },
  });
};

export const showError = (message: string) => {
  useSnackbarRef.closeSnackbar();
  useSnackbarRef.enqueueSnackbar(message || "Something went wrong", {
    variant: "error",
    style: { backgroundColor: "white", color: "red" },
  });
};
